import { api } from "../../../api"
import type { BoardType } from "../../entities/types"
import type { BoardResponseV2 } from "./board-response"
import { type BoardViewModelV2, mapBoardResponseToViewModel } from "./board-view-model"

const apiEndpoints = {
  getBoardV2: (id: string) => `/v2/boards/${id}`,
}

// allows selectBoardById to access the cache without needing to know the board type
const createGetBoardQueryKey = (id: string) => `getBoardV2 (${id})`

export const boardApiV2 = api.injectEndpoints({
  endpoints: (builder) => ({
    getBoardV2: builder.query<BoardViewModelV2, GetBoardQuery>({
      query: ({ id, type }) => ({
        url: apiEndpoints.getBoardV2(id),
        params: { type },
        method: "GET",
      }),
      serializeQueryArgs: ({ queryArgs }) => createGetBoardQueryKey(queryArgs.id),
      transformResponse: (response: BoardResponseV2) => mapBoardResponseToViewModel(response),
    }),
  }),
})

export const selectBoardV2ById = (state: any, boardId: string) => {
  const boardQuery = { id: boardId } as GetBoardQuery
  const getBoardQueryResult = boardApiV2.endpoints.getBoardV2.select(boardQuery)(state)
  return getBoardQueryResult.data || null
}

export const { useGetBoardV2Query, useLazyGetBoardV2Query } = boardApiV2

type GetBoardQuery = {
  id: string
  type: BoardType
}
